<template lang="pug">
.sec-inner
  .outline-lead.mt-3
    .campaign__detail-contents-body(v-html="detailContentsHeadHtml")
  .outline-detail
    .campaign__detail-contents-body(v-html="detailContentsBodyHtml")
</template>

<script>
import axios from 'axios'
import marked from'marked'
import {isEmpty} from 'lodash/lodash.min'

export default {

  computed: {
    detailContentsHeadHtml: function() {
      if (isEmpty(this.detailContentsHead)) {
        return ''
      }
      return marked(this.detailContentsHead.content, {
        sanitize: true,
        breaks: true
      })
    },
    detailContentsBodyHtml: function() {
      if (isEmpty(this.detailContentsBody)) {
        return ''
      }
      return marked(this.detailContentsBody.content, {
        sanitize: true,
        breaks: true
      })
    }
  },

  created() {
    this.load()
  },

  data() {
    return {
      detailContentsHead: {},
      detailContentsBody: {},
      jsonPath: (()=> {
        return location.pathname.replace(/\/$/, '') + '.json'
      })()
    }
  },

  methods: {
    load() {
      const csrf = document.querySelector('meta[name=csrf-token]')
      if (!_.isNull(csrf)) {
        axios.defaults.headers['X-CSRF-TOKEN'] = csrf.getAttribute('content')
      }
      axios.get(this.jsonPath)
        .then((response) => {
          this.detailContentsHead = response.data.result.campaign.detail_contents_head
          this.detailContentsBody = response.data.result.campaign.detail_contents_body
        })
        .catch((error) => {
          console.log(error);
        })
    }
  }

}
</script>

<style lang="sass">
@import ../../../stylesheets/modules/vendor/mamari/_custom.sass
</style>
